export default function SafetyHarborServicesSection() {
  const services = [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      desc: "As fast as 24 hours for travelers with immediate departure needs. For Safety Harbor residents facing last-minute Tampa Bay or international travel emergencies.",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      desc: "Fast renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older. Most popular option for Safety Harbor's frequent Tampa International travelers.",
    },
    {
      icon: "ri-passport-line",
      title: "New Passport",
      desc: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process at a nearby Pinellas County facility.",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      desc: "Passport replacement service including DS-64 form guidance and expedited processing. Essential for travelers who discover their passport missing before a Tampa Bay cruise or flight.",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      desc: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support. Children's passports expire in 5 years — check before every spring or summer trip.",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      desc: "Passport correction and name change service after marriage, divorce, or legal name changes. Tampa Bay newlyweds and recently divorced residents welcome.",
    },
    {
      icon: "ri-stack-line",
      title: "Second Passport",
      desc: "Second passport issuance for frequent international travelers. Ideal for Tampa business commuters and cruise regulars.",
    },
    {
      icon: "ri-shield-star-line",
      title: "Damaged Passport",
      desc: "Replacement for water-damaged, torn, or otherwise compromised passports. Guide through the replacement process included.",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      desc: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean. REAL ID compliant.",
    },
    {
      icon: "ri-vip-crown-line",
      title: "Life-or-Death Emergency",
      desc: "Same-day and next-day processing for documented life-or-death emergencies. Available 24/7 with real human support — no bots, no phone trees.",
    },
  ];

  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Services for Safety Harbor & Pinellas County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From emergency same-day processing to standard expedited service, we handle every passport situation for Safety Harbor residents — no matter how urgent.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-gray-200 p-6 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4 flex-shrink-0">
                <i className={`${s.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-7 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            View All Services & Pricing <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}